import request from '@/utils/request'

/**
 * 团队/分销相关 API
 */

/*
  邀请好友
  type：pc网站 wxmini：小程序 h5：h5 网页 app：app
  page_url：地址
*/
export function inviteFriends (data) {
  return request({
    url: '/member/team/invite_friends',
    method: 'post',
    data
  })
}

/*
  我的团队
  keywords
  type zhi直推 jian间推
*/
export function teamList (data) {
  return request({
    url: '/member/team/team_list',
    method: 'post',
    data
  })
}

/*
  账户明细
  type deposit 账号类型
  start_time 搜索开始时间（年月日）
  end_time 搜索结束时间（年月日）
  cate 类型
*/
export function creditLogs (data) {
  return request({
    url: '/member/credit/logs',
    method: 'post',
    data
  })
}

/*
  申请提现
  amount 提现金额
  method wechat|bank 提现方式
  is_personal_account 是否是对私账户 1是
  card_no 银行卡号
  name 姓名
  bank_name 银行名称（与绑卡接口 bank 字段一致，非开户行）
  bank 开户行/行号（对公必填；对私可空，绑卡时对应 bank_name 开户行）
  mobile 银行卡预留手机号（与 edit_card_page / 绑卡 mobile 一致）
  subscribe_template_id 订阅通知模板ID（wx-open-subscribe 授权后）
  subscribe_details 订阅结果 JSON（wx-open-subscribe success 返回）
*/
export function cashApply (data) {
  return request({
    url: '/finance/cash/apply',
    method: 'post',
    data
  })
}

/*
  提现记录
  time 搜索时间
  id 提现记录 id（可选，按单条筛选）
  page 页码
  page_size 每页条数
*/
export function cashList (data) {
  return request({
    url: '/finance/cash/cash_list',
    method: 'post',
    data
  })
}

/*
  邀请奖励
  page 页码
  page_size 每页条数
*/
export function inviteAward (data) {
  return request({
    url: '/member/team/invite_award',
    method: 'post',
    data
  })
}

/*
  邀请排行榜
*/
export function inviteRank (data) {
  return request({
    url: '/member/team/invite_rank',
    method: 'post',
    data
  })
}

/*
  邀请通知
*/
export function teamMsg (data) {
  return request({
    url: '/member/team/msg',
    method: 'post',
    data
  })
}
